var React = require('react');

function YoutubePlay (props) {
    return React.createElement("svg",props,[React.createElement("ellipse",{"id":"Ellipse_454","data-name":"Ellipse 454","cx":"31.5","cy":"32","rx":"31.5","ry":"32","fill":"#e43d30","opacity":"0.74","key":0}),React.createElement("path",{"id":"Polygon_5","data-name":"Polygon 5","d":"M12.5,0,25,16H0Z","transform":"translate(42 19) rotate(90)","fill":"#fff","key":1})]);
}

YoutubePlay.defaultProps = {"id":"Component_282_1","data-name":"Component 282 – 1","width":"63","height":"64","viewBox":"0 0 63 64"};

module.exports = YoutubePlay;

YoutubePlay.default = YoutubePlay;
